module.exports = __webpack_public_path__ + "img/SLIDERS.3cf28ead.svg";